import { render, staticRenderFns } from "./BaseAddress.vue?vue&type=template&id=f0c8d474&scoped=true&"
import script from "./BaseAddress.vue?vue&type=script&lang=js&"
export * from "./BaseAddress.vue?vue&type=script&lang=js&"
import style0 from "./BaseAddress.vue?vue&type=style&index=0&id=f0c8d474&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../fod/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c8d474",
  null
  
)

export default component.exports